import React from 'react';

import { UserForm } from '@/components/organisms/UserForm';
import { EditUserContext } from '@/context/EditUserContext';
import { UpdateUserFormData } from '@/DTOs/users';

interface Props {
  readonly userId?: string;
  onSubmit(formData: UpdateUserFormData): Promise<void>;
  onRemove?(): void;
}

export const EditUserForm: React.FC<Props> = (props: Props): React.ReactElement => {
  const { userId, onSubmit, onRemove } = props;

  return (
    <EditUserContext userId={userId}>
      <UserForm
        submitText="SAVE_CHANGES"
        cancelText="REMOVE"
        mode="edit"
        onSubmit={onSubmit}
        onRemove={onRemove}
      />
    </EditUserContext>
  );
};
